
/* injects from baggage-loader */

'use strict';

export default class AccountDashboardController {

	constructor($log, $timeout, $q, Activity, ActivityFeed, Product, ProductDocument, User) {
		'ngInject';

		this.$log = $log;
		this.$q = $q;
		this.$timeout = $timeout;
		this.Activity = Activity;
		this.ActivityFeed = ActivityFeed;
		this.Product = Product;
		this.ProductDocument = ProductDocument;
		this.User = User;

		this.isUserEmailVerified = true;
		this.isSendingVerificationEmail = false;
		this.isVerificationEmailSent = false;

		this.events = [];
		this.activityFeed = [];
		this.loadingEvents = false;
		this.hasMoreEvents = false;

		// Stats counters
		this.productCount = '';
		this.scanCount = '';
		this.documentCount = '';
		this.downloadCount = '';

		// Initital account completion percentage
		// this.accountCompletionPercentage = 25;

		/*
			Account completion tasks
				- Create account (completed by default)
				- Complete company profile ()

		*/

	}

	async $onInit() {

		try {
			this.isUserEmailVerified = this.User.isEmailVerified();
		} catch(e) {
			this.$log.debug('failed to read email verified status from user');
		}

		// Should display the "load more" events button
		this.hasMoreEvents = this.events.length > 9;

		// Parse activity events and fill activity feed
		this.activityFeed = this.events.map(event => this.ActivityFeed.parseEvent(event));

		// TODO: Setup account completion

		// Load counts
		this.productCount = (await this.Product.count()).toString();
		this.documentCount = (await this.ProductDocument.count()).toString();
		this.scanCount = (await this.Activity.count({ equalTo: [{ key: 'type', value: 'product-scan' }] })).toString();
		this.downloadCount = (await this.Activity.count({ equalTo: [{ key: 'type', value: 'document-dl' }] })).toString();

		this.$timeout();

		// Resolve all as a group
		// this.$q.all([
		// 	this.Product.count(),
		// 	this.ProductDocument.count(),
		// 	this.Activity.count({ equalTo: [{ key: 'type', value: 'product-scan' }] }),
		// 	this.Activity.count({ equalTo: [{ key: 'type', value: 'document-dl' }] })
		// ]).then(results => {
		// 	this.$log.debug(results);
		// 	this.$timeout();
		// })

	}


	resendInviteEmail() {
		this.isSendingVerificationEmail = true;
		this.User.resendInviteEmail()
			.then(res => {
				this.isVerificationEmailSent = true;
			})
			.catch(err => {
				// TODO: display alert if error
				this.verificationEmailSendError = "Something went wrong";
				this.isSendingVerificationEmail = false;
			})
	}


	/**
	 * Fetch some more events and append the "activityFeed" array
	 */
	loadMoreEvents() {
		this.loadingEvents = true;
		this.Activity.fetchSome({
			skip: this.activityFeed.length
		}).then(events => {
			this.hasMoreEvents = events.length ? true : false;
			this.loadingEvents = false;
			this.activityFeed = [...this.activityFeed, ...events.map(event => this.ActivityFeed.parseEvent(event))];
		});
	}



}



// WEBPACK FOOTER //
// ./src/app/pages/account/dashboard/account.dashboard.controller.js